<template>
  <div class="header page-content">
    <div class="container position-relative">
      <div
        class="header-logo position-relative d-inline-block text-center text-sm-center text-md-center text-lg-right"
      >
        <!-- Logo Anexia Container -->
        <img src="../assets/anx-logo.svg" class="anx-logo" alt="Anexia Logo" />
      </div>

      <div class="row align-items-center">
        <!-- Content Container -->

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
          <div class="title d-flex align-items-center">
            <img class="icon" src="./../assets/icon.svg" alt />
            <h1 class="pl-3">
              &mdash;
              <br /><span id="IP_title">IP-ADRESSE</span>
              <br />&mdash;
            </h1>
          </div>
          <GetIP />
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
          <div class="text-center text-sm-center text-md-center text-lg-right">
            <img
              class="grafik img-fluid flex-row-reverse"
              src="../assets/monitor.svg"
              alt="monitor"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GetIP from "./GetIP.vue";

export default {
  name: "app",
  components: {
    GetIP
  }
};
</script>

<style scoped>
.grafik {
  max-width: 417.42px;
  max-height: 450px;
  margin-bottom: 10px;
}
.header {
  background: transparent linear-gradient(180deg, #002d6e 0%, #003ca6 100%) 0%
    0% no-repeat padding-box;
}

.header-logo {
  width: inherit;
  /*margin-top: 80px;*/
  margin-bottom: 121px;
}
.anx-logo {
  width: 182px;
  height: 74px;
}
h1 {
  font-size: 35px;
  line-height: 42px;
  margin: 0px;
}
.icon {
  width: 100px;
  height: 100px;
}

.page-content {
  height: 84%;
  display: flex;
  align-items: center;
}

@media only screen and (min-width: 1000px) and (min-height: 882px) {
  .grafik {
    max-width: 417.42px;
    max-height: 450px;
    margin-bottom: 10px;
  }

  .header-logo {
    margin-bottom: 121px;
  }
}

@media only screen and (max-width: 992px) {
  .page-content {
    height: 84%;
  }
  .header {
    padding: 0px 25px 0px 25px;
  }
  .header-logo {
    width: inherit;
    margin-bottom: 49.81px;
  }
  h1 {
    font-size: 25px;
    line-height: 30px;
    margin: 0px;
  }
  .icon {
    width: 70px;
    height: 70px;
  }
  .anx-logo {
    width: 130px;
    height: 53.19px;
  }
}

@media only screen and (max-width: 599px) {
  .header {
    padding: 0px 25px 0px 25px;
  }
  .header-logo {
    width: inherit;
    margin-bottom: 49.81px;
  }
  h1 {
    font-size: 25px;
    line-height: 30px;
    margin: 0px;
  }
  .icon {
    width: 70px;
    height: 70px;
  }
  .anx-logo {
    width: 130px;
    height: 53.19px;
  }
}

@media only screen and (min-height: 1040px) and (max-height: 1120px) {
  .grafik {
    max-width: 350px;
    margin: auto;
  }
}

@media only screen and (min-height: 993px) and (max-height: 1039px) {
  .grafik {
    max-width: 350px;
    max-height: 350px;
    margin: auto;
  }
}

@media only screen and (min-height: 813px) and (max-height: 992px) and (max-width: 1024px) {
  .grafik {
    max-width: 250px;
    max-height: 213.52px;
  }
}

@media only screen and (height: 823px) {
  .grafik {
    max-width: 160px;
  }
}

@media only screen and (max-height: 812px) {
  .page-content {
    height: unset;
  }
  .grafik {
    max-width: 198px;
    max-height: 213.52px;
    margin-bottom: 57.48px;
  }
  .header-logo {
    margin-top: 50px;
    margin-bottom: 49.81px;
  }
}

@media only screen and (max-height: 812px) and (min-width: 500px) {
  .page-content {
    height: 84%;
  }
  .grafik {
    max-width: 198px;
    max-height: 213.52px;
    margin-bottom: 57.48px;
  }
  .header-logo {
    margin-top: 50px;
    margin-bottom: 50px;
  }
}

@media only screen and (max-height: 812px) and (min-width: 992px) {
  .page-content {
    height: 84%;
  }
  .grafik {
    max-width: 350px;
    max-height: 350px;
    margin-bottom: 57.48px;
  }
  .header-logo {
    margin-top: 50px;
    margin-bottom: 50px;
  }
}

@media only screen and (width: 1280px) {
  .page-content {
    height: 84%;
  }
  .grafik {
    max-width: 300px;
    height: auto;
    max-height: 100%;
    margin-bottom: 57.48px;
  }
}

@media only screen and (height: 812px) and (width: 375px) {
  .page-content {
    height: 91%;
  }
  .header-logo {
    margin-top: 50px;
    margin-bottom: 49.81px;
  }
}
</style>